module.exports = __webpack_public_path__ + "static/ArchiveVideo06-8c9f358e840a179873a24d24eed75b13.mp4";